import * as React from "react";
import {QueryClient, QueryClientProvider} from "react-query";
import {CustomerReactQuery} from "../../Settings/NotificationGroup/reactQuery/CustomerReactQuery";
import {useAppDispatch} from "../../../Config/Hooks";
import {useCallback, useEffect, useState} from "react";
import {ACard, ADataGrid, ADataGridFilter, PagedSearchParams} from "@atiautomacao/ati-ui-library";
import {extractFiltersFromColumns} from "../../../Utils/DataUitils";
import {columnsAuditLoginDataGrid} from "../../Settings/GraficElement/columnsDataGrid";
import {hideDashboardHeaderMenu} from "../../Dashboard/DashboardMenuReducer";
import {AuditLoginQuery} from "./AuditLoginReactQuery";
import {Grid} from "@mui/material";
import {DateFormat} from "../../../Utils/DateFormatPatternUtils";
import {useSnackbar} from "notistack";
import {
    applyFiltersToColumns,
    buildDateFilterSanitizationMessage,
    buildDateFilterValidationMessage,
    sanitizeDateFilters,
    validateAndConvertDateFilters,
} from "../../../Utils/AlarmDateFilterValidationUtils";


export interface LoginHistoryRow {
    id: string;
    email: string;
    hostname?: string;
    timeStamp: string;
    action: string;
    status: string;
    message: string
}


function AuditLogin() {
    const dispatch = useAppDispatch();
    const [rows, setRows] = React.useState<LoginHistoryRow[]>([]);
    const [totalOfRecords, setTotalOfRecords] = useState(0);
    const [pagedSearchParams, setPagedSearchParams] = useState(new PagedSearchParams(extractFiltersFromColumns(columnsAuditLoginDataGrid), 0, 50));
    const [columns, setColumns] = useState(() => columnsAuditLoginDataGrid);
    const {data : customers} = CustomerReactQuery();
    const selectedProfileName = customers?.data?.[0]?.name;

    const { enqueueSnackbar } = useSnackbar();


    const { data: users, isSuccess: isSuccessAuditLogin } = AuditLoginQuery(selectedProfileName, pagedSearchParams, true, true);

    useEffect(() => {
        dispatch(hideDashboardHeaderMenu())
    }, [dispatch]);

    useEffect(() => {
        if (isSuccessAuditLogin && users?.data?.totalOfRecords !== undefined) {
            setTotalOfRecords(users?.data?.totalOfRecords)
        } else {
            setTotalOfRecords(0)
        }
    }, [users?.data]);

    const updateRows = (data: any) => {
        const filteredData = data?.data?.data?.map((item: any) => {
            return {
                id: item.id,
                timeStamp: item.timeStamp != null ? DateFormat(item.timeStamp) : "",
                email: item?.email,
                status: item?.status,
                message: item?.message,
                action: item?.action,
                hostname: item?.hostname,
            };
        }).sort((a:any, b:any) => {
            return new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime();
        });

        setRows(filteredData ?? []);
    };

    useEffect(() => {
        updateRows(users);
    }, [users?.data]);


    const handleOnFiltersChange = useCallback((dataGridFilters: Array<ADataGridFilter>, page: number, pageSize: number) => {
        const sanitizedResult = sanitizeDateFilters(dataGridFilters);

        setColumns(applyFiltersToColumns(columnsAuditLoginDataGrid, sanitizedResult.filters));

        if (sanitizedResult.sanitizedFieldLabels.length > 0) {
            enqueueSnackbar(buildDateFilterSanitizationMessage(sanitizedResult.sanitizedFieldLabels), {variant: 'warning'});
            return;
        }

        const validationResult = validateAndConvertDateFilters(sanitizedResult.filters);

        if (!validationResult.isValid) {
            enqueueSnackbar(buildDateFilterValidationMessage(validationResult.invalidFieldLabels), {variant: 'error'});
            return;
        }

        const newPageParams = new PagedSearchParams(validationResult.filters, page, pageSize);
        setPagedSearchParams(
            newPageParams
        );
    }, [enqueueSnackbar]);

    return (
        <Grid item padding={1} xs={12} style={{marginTop: - 56}}>
            <ACard title="Auditoria de Login"
                   styleProps={{
                       titleStyle: {
                           fontWeight: 400,
                           fontSize: '1.5rem',
                           lineHeight: 1.334
                       }
                   }}>
                <ADataGrid
                    ariaLabel={"login-audit-grid"}
                    hideFilters={false}
                    showFilterOptions={false}
                    hideSelection={true}
                    size={"small"}
                    columns={columns}
                    rows={rows}
                    page={pagedSearchParams.page}
                    loading={false}
                    totalOfRecords={totalOfRecords}
                    onFiltersChange={handleOnFiltersChange}
                    rowsPerPage={pagedSearchParams.size}
                    actionColumnWidth={50}
                    maxHeight={700}
                />

            </ACard>
        </Grid>
    )
}

export default function AuditLoginPage() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <AuditLogin/>
        </QueryClientProvider>
    )
}
